<template>
	<div id="Main">
		<van-row type="flex" class="linklsit" justify="space-between" @click="href('/mylist',1)">
			<van-col class="img">
				<van-image width="4rem" height="4rem" fit="contain" :src="require('../../assets/images/service/my1.png')" />
			</van-col>
			<van-col class="name">红利领取</van-col>
			<van-col class="iconbox">
				<van-icon class="icon" name="arrow" />
			</van-col>
		</van-row>
		<van-row type="flex" class="linklsit" justify="space-between" @click="href('/mylist',2)">
			<van-col class="img">
				<van-image width="4rem" height="4rem" fit="contain" :src="require('../../assets/images/service/my2.png')" />
			</van-col>
			<van-col class="name">股权过出</van-col>
			<van-col class="iconbox">
				<van-icon class="icon" name="arrow" />
			</van-col>
		</van-row>
		<van-row type="flex" class="linklsit" justify="space-between" @click="href('/mylist',3)">
			<van-col class="img">
				<van-image width="4rem" height="4rem" fit="contain" :src="require('../../assets/images/service/my3.png')" />
			</van-col>
			<van-col class="name">股权过入</van-col>
			<van-col class="iconbox">
				<van-icon class="icon" name="arrow" />
			</van-col>
		</van-row>
		<van-row type="flex" class="linklsit" justify="space-between" @click="href('/mylist',4)">
			<van-col class="img">
				<van-image width="4rem" height="4rem" fit="contain" :src="require('../../assets/images/service/my4.png')" />
			</van-col>
			<van-col class="name">股权质押</van-col>
			<van-col class="iconbox">
				<van-icon class="icon" name="arrow" />
			</van-col>
		</van-row>
		<van-row type="flex" class="linklsit" justify="space-between" @click="href('/mylist',5)">
			<van-col class="img">
				<van-image width="4rem" height="4rem" fit="contain" :src="require('../../assets/images/service/my5.png')" />
			</van-col>
			<van-col class="name">股权解除质押</van-col>
			<van-col class="iconbox">
				<van-icon class="icon" name="arrow" />
			</van-col>
		</van-row>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				openId:'',
				disabled:true,
				shareholderCode:'',
				loginif:false//是否登录
			}
		},
		methods: {
			href(url, type) {
				if(!this.loginif){
					this.$router.push({
						path: "/register",
						query: {
							openId: this.openId
						}
					})
				}
				if(!this.disabled ){
					this.$toast({duration:4000,message:'实名认证通过后才能查询业务！'});
					return false;
				}
				this.$router.push({
					path: url,
					query: {
						type: type,
						user:this.shareholderCode 
					}
				})
			},
			getShare(){
				this.$toast.loading({
					message: '数据加载中...',
					forbidClick: true,
					duration: 0
				});
				axiosPost.getRealNameBindByOpenId({openId: this.openId}).then((res) => {/* 验证是否实名 */
					this.$toast.clear();
						window.console.log(res.data)
						if(res.data.data&& res.data.data.shareholderCode){
							this.loginif=true;
							if (res.data.code == 200) {
								if(res.data.data && res.data.data.authenticationStatus && res.data.data.authenticationStatus==1){
									this.shareholderCode=res.data.data.shareholderCode
								}else{
									this.$toast({duration:4000,message:'实名认证通过后才能查询业务！'});
									this.disabled=false
								}
							} else {
								this.$toast({duration:4000,message:'实名认证通过后才能查询业务！'});
								this.disabled=false
							}
						}
						else{
							this.loginif=false;
							this.$router.push({
								path: "/register",
								query: {
									openId: this.openId
								}
							})
						}
				
				}).catch((res) => {
					window.console.log(res)
				})
			}
		},
		mounted() {
			this.openId=this.$route.query.openId;
			this.getShare();
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		text-align: left;
		min-height: 100vh;
		background-color: #f2f9ff;

		.linklsit {
			padding: 1.5rem;
			background-color: #fff;
			border-radius: 8px;
			margin-bottom: 1.5rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;

			.img {
				font-size: 0;
			}

			.name {
				font-size: 1.6rem;
				line-height: 4rem;
				color: #333;
				font-weight: bold;
			}

			.iconbox {
				line-height: 4rem;
				color: rgba(0, 0, 0, .4);
			}
		}
	}
</style>
